function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagsimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.124 11.584l-4.277-6.416a1.498 1.498 0 00-1.248-.668H3.75A1.502 1.502 0 002.25 6v12a1.502 1.502 0 001.5 1.5h13.849a1.498 1.498 0 001.248-.668l4.277-6.416a.75.75 0 000-.832z",
    fill: props.fill
  }));
}

export default SvgTagsimple;